"use strict";

(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 445 ], {
  445: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    __webpack_require__.r(__webpack_exports__), __webpack_exports__.default = void (customElements.get("shopping-cart") || customElements.define("shopping-cart", class extends HTMLElement {
      form=this.querySelector("form");
      toggle=document.querySelector("#Cart");
      checkoutEl=this.querySelector("[data-fixed-checkout]");
      footerEl=document.querySelector("#shopify-section-footer");
      observer=null;
      apply=this.querySelector("[data-apply]");
      discount=this.querySelector('[name="discount"]');
      update(sections = `${this.getAttribute("data-section-id")},header`, facets = !1) {
        fetch(`${location.pathname}?sections=${sections}`, {
          method: "GET"
        }).then((response => response.json())).then((json => {
          Object.entries(json).forEach((entry => {
            const [section, html] = entry, parsedHTML = (new DOMParser).parseFromString(html, "text/html"), selector = `[id^="shopify-section"][id$="${section}"]`;
            if (facets) "object" != typeof facets && (facets = [ facets ]), facets.forEach((facet => {
              if ("[data-line-id]" === facet) {
                let incoming = parsedHTML.querySelectorAll(facet);
                for (const initem of incoming) {
                  const apEl = initem.querySelector("[data-applied-promotions]"), lipEl = initem.querySelector("[data-li-price]"), targetLine = this.querySelector(`[data-line-id="${initem.dataset.lineId}"]`);
                  if (apEl && targetLine) {
                    const targetApEl = targetLine.querySelector("[data-applied-promotions]");
                    targetApEl && (targetApEl.innerHTML = apEl.innerHTML);
                  }
                  if (lipEl && targetLine) {
                    const targetLipEl = targetLine.querySelector("[data-li-price]");
                    targetLipEl && (targetLipEl.innerHTML = lipEl.innerHTML);
                  }
                }
              } else {
                let replace = parsedHTML.querySelector(facet);
                replace && this.querySelectorAll(facet).forEach((find => find.innerHTML = replace.innerHTML));
              }
            })); else if ("header" === section) {
              const item_count = parsedHTML.querySelector("[data-cart-count]").textContent;
              document.querySelectorAll("[data-cart-count]").forEach((count => {
                count.textContent = item_count.trim();
              }));
            } else document.querySelectorAll(selector).forEach((el => {
              location.href.match(/\/cart$/) ? el.innerHTML = parsedHTML.querySelector(selector).innerHTML : el.innerHTML = this.toggle.checked ? parsedHTML.querySelector(selector).innerHTML.replace('id="Cart"', 'id="Cart" checked') : parsedHTML.querySelector(selector).innerHTML;
            }));
          }));
        }));
      }
      open() {
        this.toggle.checked = !0, this.toggle.dispatchEvent(new Event("change"));
      }
      close() {
        this.toggle.checked = !1, this.toggle.dispatchEvent(new Event("change"));
      }
      updateCount() {
        this.update("header"), this.updateFacets();
      }
      handleChange(event) {
        this.form && (event.preventDefault(), event.stopPropagation(), fetch(window.routes.cart_update_url, {
          method: "POST",
          body: new URLSearchParams(new FormData(this.form)),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }).then((response => {
          if (200 === response.status) return response.json();
          console.error(response), location.href = event.target.href;
        })).then((cart => {
          this.updateLinks(event.target), cart.items.length > 0 && this.updateRecommendations(cart.items[0].product_id);
        })).catch((error => {
          console.error(error), this.form?.submit();
        })));
      }
      updateLinks(el) {
        const row = el.closest("[data-line-item]");
        if (row) {
          const matches = el.href.match(/=([0-9]+)/);
          if (matches && matches.length > 1) {
            const quantity = parseInt(matches[1]);
            if (row.querySelector('[type="number"]').value = quantity, quantity <= 0) {
              this.updateFacets(el.hasAttribute("data-remove"));
              try {
                row.classList.add("opacity-0", "max-h-0"), row.classList.remove("max-h-screen"), 
                setTimeout((() => row.parentNode.removeChild(row)), 400);
              } catch (e) {}
            } else row.querySelector("[data-minus]").href = row.querySelector("[data-minus]").href.replace(/[0-9]+$/, quantity - 1), 
            row.querySelector("[data-plus]").href = row.querySelector("[data-plus]").href.replace(/[0-9]+$/, quantity + 1);
          }
        }
        this.updateCount();
      }
      updateFacets(removal = !1) {
        this.update(this.getAttribute("data-section-id"), [ removal ? "[data-cart-page-recommendations]" : null, "[data-line-id]", "[data-cart-delivery]", "[data-cart-promotion]", "[data-cart-total]" ].filter(Boolean));
      }
      updateRecommendations(product_id) {
        product_id && this.querySelectorAll("product-recommendations").forEach((el => {
          const matches = el.dataset.url.match(/product_id=([0-9]+)/);
          matches && parseInt(matches[1]) !== product_id && (el.dataset.url = el.dataset.url.replace(matches[1], product_id));
        }));
      }
      saveDiscount(code = "") {
        var formData = new FormData;
        formData.append("attributes[_Discount]", code), fetch(Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(Object.fromEntries(formData))
        }).then((() => this.update())).catch((error => {
          console.warn("Failed to update cart with discount:", error);
        }));
      }
      applyDiscount() {
        const code = this.discount?.value;
        code && fetch(`/discount/${code}`).then((response => {
          if (response.ok) return response;
          throw new Error(response.statusText);
        })).then((() => {
          this.saveDiscount(code);
        })).catch((error => {
          console.warn(error);
        }));
      }
      handleClick(event) {
        (event.target.hasAttribute("data-remove") || event.target.hasAttribute("data-minus") || event.target.hasAttribute("data-plus")) && (event.preventDefault(), 
        event.stopPropagation(), fetch(event.target.href, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }).then((response => {
          if (200 === response.status) return response.json();
          console.error(response), location.href = event.target.href;
        })).then((cart => {
          0 === cart.item_count ? this.update() : (this.updateLinks(event.target), cart.items.length > 0 && event.target.hasAttribute("data-remove") && this.updateRecommendations(cart.items[0].product_id));
        })).catch((error => {
          console.error(error), location.href = event.target.href;
        })).finally((() => {
          event.target && event.target.classList.remove("pointer-events-none");
        })));
      }
      handleObserver() {
        return new IntersectionObserver((entries => {
          for (const entry of entries) this.checkoutEl.style.opacity = entry.isIntersecting ? 0 : null, 
          this.checkoutEl.style.pointerEvents = entry.isIntersecting ? "none" : null;
        }), {
          threshold: .1
        });
      }
      setupTablet() {
        this.observer = this.handleObserver(), this.observer.observe(this.footerEl);
      }
      destroyTablet() {
        this.observer && (this.observer.unobserve(this.footerEl), this.observer = null);
      }
      constructor() {
        super();
      }
      connectedCallback() {
        if (window.addEventListener("cart:added", (event => {
          event.stopImmediatePropagation(), event.preventDefault(), event.stopPropagation(), 
          this.update(), setTimeout((() => this.open()), 200);
        })), this.form) {
          if (this.form.addEventListener("change", (event => this.handleChange(event))), this.form.addEventListener("input", (event => this.handleChange(event))), 
          this.querySelectorAll("[data-remove],[data-plus],[data-minus]").forEach((el => el.addEventListener("click", (event => {
            el.classList.add("pointer-events-none"), this.handleClick(event);
          })))), this.checkoutEl) {
            const tabletMQ = window.matchMedia("(max-width: 1024px)");
            tabletMQ.matches && this.setupTablet(), tabletMQ.addEventListener("change", (e => {
              e.matches ? this.setupTablet() : this.destroyTablet();
            }));
          }
          this.discount && this.apply && this.apply.addEventListener("click", (event => {
            event.preventDefault(), event.stopPropagation(), this.applyDiscount();
          })), location.href.includes("/products/") && new MutationObserver(((mutationsList, observer) => {
            mutationsList.forEach((mutation => {
              mutation.target.querySelectorAll(".loop-toast.success").length && this.dispatchEvent(new CustomEvent("cart:added", {
                bubbles: !0
              }));
            }));
          })).observe(document.querySelector("body"), {
            childList: !0,
            subtree: !0,
            characterData: !1,
            attributes: !1
          });
        }
      }
    }));
  }
} ]);